export default __webpack_public_path__ + "images/a355110ae7ecdcc3c495ab1888462184-bridge.png";